<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>
<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'

const animationDuration = 6000

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
	  
	// 获取当月第一天
	const firstDay = this.$moment().startOf('month');
	 
	// 获取当月最后一天
	const lastDay = this.$moment().endOf('month');
	
	this.$api.post("/admin/census/getIndexBar", {
		beginTime: this.$moment(firstDay).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
		endTime: this.$moment(lastDay).format(
          "YYYY-MM-DD HH:mm:ss"
        )
	}).then((res) => {

		  this.chart.setOption({
			calculable: true,
			// dataZoom: [
			//     //1.横向使用滚动条
			//     {
			//         type: 'slider',//有单独的滑动条，用户在滑动条上进行缩放或漫游。inside是直接可以是在内部拖动显示
			//         show: true,//是否显示 组件。如果设置为 false，不会显示，但是数据过滤的功能还存在。
			//         start: 0,//数据窗口范围的起始百分比0-100
			//         end: 50,//数据窗口范围的结束百分比0-100
			//         xAxisIndex: [0],// 此处表示控制第一个xAxis，设置 dataZoom-slider 组件控制的 x轴 可是已数组[0,2]表示控制第一，三个；xAxisIndex: 2 ，表示控制第二个。yAxisIndex属性同理
			//         bottom: -20 //距离底部的距离
			//     },
			// ],
			legend: {
			  //   指示框名字  注意！要和下方series中的name一起改
			  data: ['当月出单', '当月退单'],
			  // 指示框位置  距离上下左右多少
			  right: '5%',
			  textStyle: {
				  color: '#4F4F4F'   ,//字体颜色
			  }
			},
			xAxis: [{
			  type: 'category',
			  data: res.data.org,
			  axisTick: {
				alignWithLabel: true
			  }
			}],
			yAxis: [{
			  type: 'value',
			  axisTick: {
				show: false
			  }
			}],
			grid: {
			  top: 10,
			  left: '1%',
			  right: '2%',
			  bottom: '3%',
			  containLabel: true
			},
			series: [{
				barWidth: 20,//柱子宽度
				name: '当月出单',
				type: 'bar',
				data: res.data.bill,
				itemStyle: {
					//颜色样式部分
					normal: {
						barBorderRadius: [20, 20, 0, 0],  //圆角[上左，上右，下右，下左] 
						label: {
							show: true, //开启数字显示         
							position: 'top', //在上方显示数字         
							textStyle: { //数值样式          
								color: '#474646',  //字体颜色
								fontSize: 10       //字体大小
							}
						},
						//   柱状图颜色渐变
						color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
							{ offset: 0, color: "#017CE4" },
							{ offset: 1, color: "#249EFD" },
						]),
					}
				}

			},
			{
				barWidth: 20,//柱子宽度
				name: '当月退单',
				type: 'bar',
				data: res.data.return,
				itemStyle: {
					//颜色样式部分
					normal: {
						barBorderRadius: [20, 20, 0, 0],  //圆角[上左，上右，下右，下左] 
						label: {
							show: true, //开启数字显示         
							position: 'top', //在上方显示数字          
							textStyle: { //数值样式          
								color: '#474646',   //字体颜色
								fontSize: 10        //字体大小
							}
						},
						//   柱状图颜色渐变
						color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
							{ offset: 0, color: "#e952e7" },
							{ offset: 1, color: "#e94399" },
						]),
					}
				}
			}]
		  })
	  });
    }
  }
}
</script>